import { render, staticRenderFns } from "./OrderSameBreakfastDialog.vue?vue&type=template&id=1969e3ae&scoped=true&"
import script from "./OrderSameBreakfastDialog.vue?vue&type=script&lang=js&"
export * from "./OrderSameBreakfastDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1969e3ae",
  null
  
)

export default component.exports